@import 'styles/variables.scss';

.formatBar {
  padding-left: 254px;
}

.inputContainer {
  flex: 1;
  transition: width 250ms ease-in-out;
  display: flex;
  align-items: center;
  position: absolute;
  left: 4px;
}

.buttonContainer {
  transition: width 250ms ease-in-out;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 1px;
}

.promptFocused {
  .buttonContainer {
    visibility: hidden;
  }
}
